export default {
  seaLiceTitle: { id: 'sea_lice_monitor' },
  sites: { id: 'sites' },
  site: { id: 'site' },
  seaLice: { id: 'sea_lice' },
  treatments: { id: 'treatments' },
  countSummary: { id: 'count_summary' },
  totalSeaLice: { id: 'total_sea_lice' },
  juvenile: { id: 'juvenile' },
  mobileAdults: { id: 'mobile_adults' },
  gravidFemales: { id: 'gravid_females' },
  filterList: { id: 'filter_list' },
  selectReport: { id: 'select_report' },
  previous: { id: 'previous' },
  updateText: { id: 'data_available' },
  chooseReport: { id: 'choose_report' },
  mySites: { id: 'my_sites' },
  allSites: { id: 'all_sites' },
  allBarrios: { id: 'all_barrios' },
  siteList: { id: 'site_list' },
  barriosList: { id: 'barrios_list' },
  species: { id: 'species' },
  barrios: { id: 'barrios' },
  barrio: { id: 'barrio' },
  type: { id: 'type' },
  view: { id: 'view' },
  mapView: { id: 'map_view' },
  siteComparison: { id: 'site_comparison' },
  all: { id: 'all' },
  weeklySummary: { id: 'weekly_summary' },
  juveniles: { id: 'juvenile' },
  mobile_adult: { id: 'mobile_adults' },
  pregnant_female: { id: 'gravid_females' },
  total_count: { id: 'total_sea_lice' },
  view_more: { id: 'view_more' },
  sitesOf: { id: 'sites_of' },
}
